import { Box, styled } from '@mui/material';
import { useState } from 'react';

import { ENOPOrganType, EResourceType } from '#shared';

import { CellDrawerHeader } from './CellDrawerHeader';
import { CellDrawerRoot } from './CellDrawerRoot';
import { CellHumanDrawerContent } from './CellHumanDrawerContent';
import { ToggleGroupSection } from './ToggleGroupSection';

import type { HumanResource } from '#entities';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  regionName: string;
  data?: Partial<Record<ENOPOrganType, HumanResource[]>>;
};

const organOptions: ENOPOrganType[] = [
  ENOPOrganType.Liver,
  ENOPOrganType.Heart,
  ENOPOrganType.Lungs,
];

const ToggleGroupBox = styled(Box)(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(0.5),
}));

export const SurgeonDetails = ({
  isOpen,
  onClose,
  regionName,
  data,
}: Props) => {
  const [selectedDay, setSelectedDay] = useState<'today' | 'tomorrow'>('today');
  const [selectedOrgan, setSelectedOrgan] = useState<ENOPOrganType>(
    ENOPOrganType.Liver,
  );
  const currentResources = data?.[selectedOrgan] ?? [];
  const mappedRegionName = regionName === 'South' ? 'Texas' : regionName;

  return (
    <CellDrawerRoot open={isOpen} anchor="right" onClose={onClose}>
      <CellDrawerHeader
        onClose={onClose}
        day={selectedDay}
        organ={selectedOrgan}
        secondaryText={mappedRegionName}
        title="Surgeons"
      />

      <ToggleGroupBox>
        <ToggleGroupSection
          options={organOptions}
          value={selectedOrgan}
          onChange={setSelectedOrgan}
        />

        <ToggleGroupSection
          options={['today', 'tomorrow']}
          value={selectedDay}
          onChange={setSelectedDay}
        />
      </ToggleGroupBox>

      <Box>
        <CellHumanDrawerContent
          day={selectedDay}
          resources={currentResources}
          title="Surgeons"
          type={EResourceType.Surgeon}
          selectedOrgan={selectedOrgan}
        />
      </Box>
    </CellDrawerRoot>
  );
};
